<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body">
                <el-row>
                    <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-input  placeholder="请输入手机号" v-model="idCard" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
                    </div>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="400">
                            <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                            <!-- <el-table-column prop="checkinList" width="100" label="入住状态">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.checkinStatus==1" type="success">入住中</el-tag>
                                    <el-tag v-if="scope.row.checkinStatus==0" type="primary">未入住</el-tag>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="地址" prop="areaName" ></el-table-column>
                            <el-table-column label="详细住址" prop="address" ></el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">绑定</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px 5px 20px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    export default {
        name: 'GetElderly',
        data() {
            return {
                showModalAdd:false,
                name:'',
                idCard:'',
                loading: false, 
                elderlyInfo:[],
                totalItems:0,
                pageSize: 20,
                currentPage: 1,
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                zoneValue: [],
                zoneCode: '',
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        methods: {
            init(){
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeGetElderly");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getElderly();
            },
            handleAdd(index, row) {
                this.$emit("setElderly",row);
                this.$emit("closeGetElderly");
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            getTime(row,index,column){
                return timefilters(column)
            },
            userStatus(row) {
                if (row.userStatus == 1) {
                    return "正常";
                }
                if (row.userStatus == 2) {
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.$emit('getList')
                this.$emit("closeGetElderly");
            },
            getElderly(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/PageForInstitutionCode",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        idCard:this.idCard,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
                height: 100%;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
